export default `
  mutation revokeMcpClientConnection($clientId: String!) {
    revokeMcpClientConnection(clientId: $clientId)
  }
`
